import { render, staticRenderFns } from "./medal_send.vue?vue&type=template&id=df28158a&scoped=true"
import script from "./medal_send.vue?vue&type=script&lang=ts"
export * from "./medal_send.vue?vue&type=script&lang=ts"
import style0 from "./medal_send.vue?vue&type=style&index=0&id=df28158a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df28158a",
  null
  
)

export default component.exports